import { Component, Input, OnInit, OnChanges, HostBinding, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { ControlType } from '../../entity/controltype';
import { HelpContol } from '../../entity/controltype/help/helpcontrol';
import { IControl } from '../../entity/controltype/icontrol';
import { SolutionService } from '../../service/solution.service';
import { HelpValue } from '../../entity/conditionvalue/helpvalue';
import { DisplayType } from '../../entity/controltype/help/displayType';

// import { ServerSideToken } from '@farris/ui-lookup';
// import { LookupHttpBeQueryService } from './service/Lookup-http.service';
import { of } from 'rxjs';

@Component({
    selector: 'app-filter-help',
    templateUrl: './help.component.html'
    // providers: [{ provide: ServerSideToken, useClass: LookupHttpBeQueryService }]
})

export class HelpComponent implements OnInit, OnChanges {

    /**
     * QueryCondition类型
     */
    @Input() item: any;
    @Input() autoLabel: boolean;
    @Input() disabled: boolean;

    @Input() hostRef: any;

    @Input() instanceId: string;

    @Output() searchHandle = new EventEmitter();

    uri: string;
    textField: string;
    idField: string;
    valueField: any;
    textValue: any;
    displayType: DisplayType;
    mapFields: any;
    context: any;
    preEventCmd: any;
    postEventCmd: any;
    enableFullTree: boolean;
    loadTreeDataType: 'default' | 'loadall' | 'layerload';
    singleSelect: boolean;
    expandLevel: number;
    enableCascade: boolean;
    helpId: string;
    title: string;

    /** 判断是否是在扩展区域展示 */
    extend = false;
    /** 判断是否显示label */
    showlabel = true;
    placeholder: string;

    editable = false;
    /** 多字段查询 */
    enableMultiFieldSearch = false;

    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }
    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }
      /**
     * 某个字段发生值变化事件时，需要同步清空的字段，可能不是当前字段
     */
    @Input() changeFields: Array<string> = [];
    /**
     * 要清空的关联字段
     */
    clearFields: string;
    constructor(private solutionService: SolutionService) { }

    ngOnInit(): void {
        if (this.item) {
            const type = Object.prototype.toString.call(this.item.placeHolder);
            if (type == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.placeholder = this.item.control.placeholder;
                }
            } else {
                this.placeholder = this.item.placeHolder;
            }
        }
        this.getHelpBindingInfo();
        if (this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')) {
            this.extend = this.item.control.isExtend;
            if (!this.extend) {
                this.showlabel = this.item.control.showLabel;
            }
        }

        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);

        (this.item.value as HelpValue).clear$.subscribe(() => {
            this.textValue = '';
        });
        
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getHelpBindingInfo();
        if(changes['changeFields'] && changes['changeFields'].currentValue && !changes['changeFields'].firstChange) {
            const isChange = changes['changeFields'].currentValue.some(field => field == this.item.fieldCode);
            if(isChange){
                this.textValue = (this.item.value as HelpValue).textValue;
            }
        }
    }

    selectedDataHandler(selectedItem: any) {
        // console.log(selectedItem);
        //    let mapFields=new Function('return'+(this.item.control as HelpContol).mapFields);
        //    let mapFieldsKeys=Object.keys(mapFields());
        //    (this.item.value as HelpValue).value=new Object();
        //    mapFieldsKeys.forEach(mapFeildKey => {
        //     (this.item.value as HelpValue).value[mapFeildKey]=selectedItem[mapFeildKey];
        //    });
        //    (this.item.value as HelpValue).valueField=(this.item.control as HelpContol).valueField;
        //    let textField=(this.item.control as HelpContol).textField;
        //    this.textValue=(this.item.value as HelpValue).value[textField];

        const helpValue = (this.item.value as HelpValue);
        helpValue.value = this.singleSelect ? [selectedItem] : selectedItem; // 单选返回对象，多选返回数组
        helpValue.valueField = this.valueField;
        helpValue.textValue = helpValue.getTextValue(this.textField);
        this.textValue = helpValue.textValue;
        // this.conditionChange.emit();
        if (this.disabled) { return; }
        this.searchHandle.emit();

    }

    getHelpBindingInfo() {
        if (this.item && this.item.control && this.item.control.getControlType() == ControlType.Help) {
            const helpList = (this.item.control as HelpContol);
            this.uri = helpList.uri;
            this.textField = helpList.textField;
            this.valueField = helpList.valueField;
            this.idField = helpList.idField;
            this.mapFields = helpList.mapFields;
            this.context = helpList.context;
            if (helpList.preEventCmd) {
                this.preEventCmd = (e) => {
                    e['hostRef'] = this.hostRef;
                    return helpList.preEventCmd(e);
                };
            }

            if (helpList.postEventCmd) {
                this.postEventCmd = (e) => {
                    e['hostRef'] = this.hostRef;
                    return helpList.postEventCmd(e);
                };
            }
            this.singleSelect = helpList.singleSelect;
            this.enableFullTree = helpList.enableFullTree;
            this.loadTreeDataType = helpList.loadTreeDataType;
            this.expandLevel = helpList.expandLevel;
            this.enableCascade = helpList.enableCascade;
            this.helpId = helpList.helpId;
            this.title = helpList.title;
            const helpValue = (this.item.value as HelpValue);
            this.clearFields = helpList.clearFields;
            // if (helpValue && helpValue.value) {
            //     // this.textValue = (this.item.value as HelpValue).value[this.textField];
            //     this.textValue = HelpValue.getPropValue(helpValue.value, this.textField.split('.'));
            // }
            this.displayType = helpList.displayType;
            if (helpValue.textValue == 'help-text-value-null') {// 旧数据兼容
                this.textValue = helpValue.getTextValue(this.textField);
            } else {
                this.textValue = helpValue.textValue;
            }

            this.editable = !!helpList.editable;
            this.enableMultiFieldSearch = !!helpList.enableMultiFieldSearch;
        }
    }

    // getConditionItemStyle(field: QueryCondition, controlType: any) {
    //     return this.solutionService.getConditionItemStyle(field,controlType);
    // }

    getConditionItemTitle(field: QueryCondition) {
        return this.solutionService.getConditionItemTitle(field);
    }

    onSearch = () => {
        if (this.disabled) { return; }
        this.searchHandle.emit();
        return of(true);
    }

    clearData(data: any) {
        (this.item.value as HelpValue).clearValue();
        this.searchHandle.emit();
    }

}
